// generic-client
import { createContext, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useLeanplum } from './useLeanplum/useLeanplum';

export const NotificationsContext = createContext({});

function mergeNotifications(...tails) {
  return tails
    .reduce((head, tail) => tail.concat(head), [])
    .filter((one) => one.read === false)
    .sort((a, b) => b.date - a.date);
}

export const NotificationsProvider = function ({ children }) {
  // Some context is needed to perform this art.
  const leanplum = useLeanplum();
  const history = useHistory();
  const { enabledPushNotifications, togglePushNotifications } = leanplum;

  const list = mergeNotifications(leanplum.notifications);
  const counter = list.length;

  function onNotificationOpening(notification) {
    if (notification.to) {
      if (notification.to.startsWith('/')) {
        history.push(notification.to);
      } else {
        window.open(notification.to, '_blank', 'noopener noreferrer');
      }
    }
    if (notification.type === 'leanplum') {
      leanplum.manager.markNotificationAsRead(notification.id);
    }
  }

  function markAllRead() {
    const leanplums = list.filter((one) => one.type === 'leanplum').map((one) => one.id);
    if (leanplums.length > 0) {
      leanplum.manager.batchNotificationsAsRead();
    }
  }

  const notifications = useMemo(
    () => ({
      list,
      counter,
      onNotificationOpening,
      enabledPushNotifications,
      togglePushNotifications,
      markAllRead,
      isWebPushSupported: leanplum.isWebPushSupported,
    }),
    [
      list,
      counter,
      onNotificationOpening,
      enabledPushNotifications,
      togglePushNotifications,
      markAllRead,
      leanplum.isWebPushSupported,
    ],
  );

  return (
    <NotificationsContext.Provider value={notifications}>{children}</NotificationsContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
